export default __webpack_public_path__ + "static/media/surprised-icon.f72ee41d.svg";